export default function propsProvider(props) {
    /*
          - To only list utilized props
          - Wrapping utilized props on each view
      */
    const { intl, onForgetPwClick, onSubmitClick, formik, errorMessage } = props;
    return {
        intl,
        onForgetPwClick,
        onSubmitClick,
        formik,
        errorMessage,
    };
}
